import { Checkbox } from '@winnin/winnin_ui.components.checkbox'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import BlockComponentsRole75Checker from 'components/BlockComponentsRole75Checker'
import { useSelectedItemsList } from 'contexts/SelectedItemsListProvider'
import { useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'

import './index.scss'

function AddToCreatorCheckbox({ id, provider, title, thumbnail, groupId }) {
  const { selectedItemsBar, removeItem, addItem } = useSelectedItemsList()

  const checkIsActive = selectedItemsBar?.some(check => check.id === id)
  const isUserViewer = UserStore.getRole === 'viewer'
  const isUserAllowed = UserStore?.userInfo?.role > 50
  const t = useTranslate()

  function handleSelectionDefaultPrevented(e) {
    e.preventDefault()
    e.stopPropagation()

    const isItemSelected = selectedItemsBar.find(item => item.id === id)
    if (isItemSelected) {
      removeItem(isItemSelected)
      return
    }
    addItem({ id: id, name: title, type: 'creators', provider: provider, thumbnail: thumbnail, groupId: groupId })
  }

  if (isUserViewer || !isUserAllowed) return null

  return (
    <div className="AddToCreatorCheckbox">
      <BlockComponentsRole75Checker isClickBlocked={!isUserAllowed}>
        <TooltipWrapper
          tooltipMessage={t({ key: 'AddToCreatorCheckbox-tooltip', defaultValue: 'Select this creator' })}
          tooltipStyle="tooltippedS"
        >
          <Checkbox
            isActive={checkIsActive}
            handleClick={handleSelectionDefaultPrevented}
            className="CreatorCard-first-column-checkbox"
          />
        </TooltipWrapper>
      </BlockComponentsRole75Checker>
    </div>
  )
}

export default AddToCreatorCheckbox
